import { createAction } from '@ngrx/store';

export enum AppActionTypes {
  AppReady = '[App] AppReady',
}

export const appReadyAction = createAction(AppActionTypes.AppReady);

export type AppAction = typeof appReadyAction;
